 <div id="reset-forgot-password-container" fxLayout="column" fxLayoutAlign="center center">
  <mat-card class="example-container" fxFlex="30%" fxFlex.lt-md="65%" fxFlex.lt-sm="95%">
      <div *ngIf = "!isLinkValid" class = "api-error">{{linkExpirationText}}</div>
      <form [formGroup]="resetForm" (ngSubmit)="submitFun()" *ngIf = "isLinkValid">
        <mat-card-title class="center">
          {{titleText }}
          <br>
          <div class = "password-help-text">
            <p class="infoMessage">{{passwordGuidelinesTitleText}}</p>
            <ul *ngIf = "guidelines">
              <li *ngIf = "guidelines.minimumLength"> {{ 'Has' }} {{ 'atleast'}} {{' '+ guidelines.minimumLength + ' '}} {{'characters' }}</li>
              <li *ngIf = "guidelines.requireUppercase"> {{ 'Has'}} {{' '}} {{ 'an uppercase letter'}}</li>
              <li *ngIf = "guidelines.requireLowercase">{{ 'Has'}} {{' '}} {{ 'a lowercase letter'}}</li>
              <li *ngIf = "guidelines.requireNumbers">{{ 'Has'}} {{' '}} {{ 'a number' }}</li>
              <li *ngIf = "guidelines.requireSymbols">{{ 'Has'}} {{' '}} {{ 'a symbol' }}</li>
              <li>{{'New Password and Confirm Password should be same' }}</li>
            </ul>
          </div> 
        </mat-card-title>
        <mat-error class = "password-error" *ngIf="(error.passwordError === true)"> {{error.msg}}</mat-error>
        <mat-card-content>
            <mat-form-field>
              <label>{{newPasswordText}}</label>
              <input matInput [type]="hide2 ? 'password' : 'text'" formControlName="proposedPassword">
              <mat-icon fontSet="material-icons-outlined" matSuffix (click)="hide2 = !hide2">
                {{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="errorHandling('proposedPassword', 'required')">
                {{newPasswordError }}
               </mat-error>
              <mat-error *ngIf="!errorHandling('proposedPassword', 'required') && errorHandling('proposedPassword', 'password')">
                {{passwordValidationMessage}}
             </mat-error>
              <mat-error *ngIf="errorHandling('proposedPassword', 'minlength')">
                minimum 8 characters required
            </mat-error>
            </mat-form-field>
            <mat-form-field >
              <label>{{confirmPasswordText}}</label>
              <input matInput [type]="hide3 ? 'password' : 'text'" formControlName="reEnterPassword">
              <mat-icon fontSet="material-icons-outlined" matSuffix (click)="hide3 = !hide3">
                {{hide3 ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error *ngIf="errorHandling('reEnterPassword', 'required')">
                {{confirmPasswordError}}
               </mat-error>
              <mat-error *ngIf="!errorHandling('reEnterPassword', 'required') && errorHandling('reEnterPassword', 'passwordConfirmation')">
                {{confirmPasswordError }}
             </mat-error>
            </mat-form-field>
            <mat-error *ngIf="(error.error === true)">{{error.msg}} </mat-error>
            <P class="success" *ngIf="(error.success === true)">{{error.msg}}</P>
        </mat-card-content>
            <mat-card-actions class = "right center-align">
              <button mat-flat-button [disabled]="!resetForm.valid" style="margin-top: 20px;">{{ buttonText }}</button>
            </mat-card-actions>
    </form>
  
  </mat-card> 
  </div> 
